import { Decimal } from "@cosmjs/math";

export function nFormatter(num: number, digits: number) {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function udenomToDenom(_amount: string | number, precision = 6, decimals: number = 1_000_000) {
  const amount = typeof _amount === "string" ? parseFloat(_amount) : _amount;
  return roundDecimal(amount / decimals, precision);
}

/**
 * @deprecated don't use JS floating point number to represent a denom amount.
 * use the string representation instead and use `Decimal` from `@cosmjs/math` to do manipulation on amounts.
 */
export function denomToUdenom(amount: number): number;
export function denomToUdenom(amount: string): number;
export function denomToUdenom(amount: string | number) {
  return Number(Decimal.fromUserInput(amount.toString(), 6).atomics);
}

export function roundDecimal(value: number, precision = 2) {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
}

export function ceilDecimal(value: number) {
  return Math.ceil((value + Number.EPSILON) * 1000) / 1000;
}

export function percIncrease(a: number, b: number) {
  if (a === 0) {
    return 0;
  }

  const percent = b !== 0 ? (b - a) / a : -1;
  return roundDecimal(percent, 4);
}
